const fixPath = (path) => path.replace(/\/\//g, '/')

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(fixPath(`${process.env.PUBLIC_URL}/service-worker.js`))
      .catch((registrationError) => {
        // eslint-disable-next-line
        console.error('SW registration failed: ', registrationError)
      })
  })
}
